import { render } from "./OptionalRule.vue?vue&type=template&id=543fb1c7&scoped=true"
const script = {}

import "./OptionalRule.vue?vue&type=style&index=0&id=543fb1c7&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543fb1c7"]])

export default __exports__